module.exports = __webpack_public_path__ + "img/unnamed.ee00d244.png";